import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFilters, initialFilterState } from 'types/VehicleIncidents';

export interface VehicleIncidentState {
	commentsOpen: boolean;
	commentIncidentId: number | null;
	incidentBranchId: string | null;
	incidentReportOpen: boolean;
	incidentReportId: number | null;
	incidentSection1Id: number | null;
	incidentSection2Id: number | null;
	incidentSection3Id: number | null;
	incidentSection4Id: number | null;
	incidentSection5Id: number | null;
	isNewIncident: boolean;
	filters: IFilters;
}

export interface CommentPayload {
	commentIncidentId: number | null;
	incidentBranchId: string | null;
}

export interface VehicleIncidentReportState {
	incidentReportId: number | null;
	incidentSection1Id?: number | null;
	incidentSection2Id?: number | null;
	incidentSection3Id?: number | null;
	incidentSection4Id?: number | null;
	incidentSection5Id?: number | null;
	isNewIncident?: boolean;
}

const initialState: VehicleIncidentState = {
	commentsOpen: false,
	commentIncidentId: null,
	incidentBranchId: null,
	incidentReportOpen: false,
	incidentReportId: null,
	isNewIncident: false,
	incidentSection1Id: null,
	incidentSection2Id: null,
	incidentSection3Id: null,
	incidentSection4Id: null,
	incidentSection5Id: null,
	filters: initialFilterState,
};

const vehicleIncidentSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		openCommentModal(state, action: PayloadAction<CommentPayload>) {
			const payload = action.payload;
			state.commentIncidentId = payload.commentIncidentId;
			state.incidentBranchId = payload.incidentBranchId;
			state.commentsOpen = true;
		},
		closeCommentModal(state) {
			state.commentIncidentId = null;
			state.incidentBranchId = null;
			state.commentsOpen = false;
		},
		openIncidentModal(
			state,
			action: PayloadAction<VehicleIncidentReportState>
		) {
			const payload = action.payload;
			state.incidentReportId = payload?.incidentReportId || null;
			state.incidentReportOpen = true;
			state.incidentSection1Id = payload?.incidentSection1Id || null;
			state.incidentSection2Id = payload?.incidentSection2Id || null;
			state.incidentSection3Id = payload?.incidentSection3Id || null;
			state.incidentSection4Id = payload?.incidentSection4Id || null;
			state.incidentSection5Id = payload?.incidentSection5Id || null;
			state.isNewIncident = payload?.isNewIncident || false;
		},
		updateIncidentSectionId(
			state,
			action: PayloadAction<VehicleIncidentReportState>
		) {
			const payload = action.payload;
			state.incidentReportId = payload?.incidentReportId || null;
			state.incidentSection1Id = payload?.incidentSection1Id || null;
			state.incidentSection2Id = payload?.incidentSection2Id || null;
			state.incidentSection3Id = payload?.incidentSection3Id || null;
			state.incidentSection4Id = payload?.incidentSection4Id || null;
			state.incidentSection5Id = payload?.incidentSection5Id || null;
			state.isNewIncident = payload?.isNewIncident || false;
		},
		closeIncidentModal(state) {
			state.incidentReportId = null;
			state.incidentReportOpen = false;
			state.isNewIncident = false;
		},
		updateIncidentFilterState(state, action: PayloadAction<IFilters>) {
			state.filters = action.payload;
		},
		resetIncidentFilterState(state) {
			state.filters = initialFilterState;
		},
	},
});

export const {
	openCommentModal,
	closeCommentModal,
	openIncidentModal,
	closeIncidentModal,
	updateIncidentFilterState,
	updateIncidentSectionId,
	resetIncidentFilterState,
} = vehicleIncidentSlice.actions;
export default vehicleIncidentSlice.reducer;
